import apiService from "@/lib/api";

const TENANT_BASE = "/api/v2/admin/tenants";

export const TenantService = {
    fetchTenantList: async ({
        page = 1,
        per_page = 10,
        pagination = true,
        search = '',
        ...param
    }) => {
        const params = {
            page,
            per_page,
            search,
            pagination,
            ...param
        };
        try {
            const response = await apiService.getSecure(`${TENANT_BASE}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error while fetching list:', error);
            throw error;
        }
    },

    fetchTenantById: async (id) => {
        try {
            const response = await apiService.getSecure(`${TENANT_BASE}/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error while fetching tenant:', error);
            throw error;
        }
    },

    /**
     * Create a tenant. Payload keys expected: name, slug, region, maxUsers,
     * adminName, adminEmail, dbMode ('shared' | 'dedicated').
     *
     * For dedicated mode the backend runs the provisioning saga inline —
     * the request can take a few seconds. Callers should surface a spinner.
     */
    createTenant: async (payload) => {
        try {
            const response = await apiService.postSecure(`${TENANT_BASE}`, payload);
            return response.data;
        } catch (error) {
            console.error('Error while creating tenant:', error);
            throw error;
        }
    },

    updateTenant: async (tenantId, payload) => {
        try {
            const response = await apiService.patch(`${TENANT_BASE}/${tenantId}`, payload);
            return response.data;
        } catch (error) {
            console.error('Error while updating tenant:', error);
            throw error;
        }
    },

    statusChange: async (tenantId, status) => {
        try {
            const payload = {
                isActive: status,
                reason: null,
            }
            const response = await apiService.patch(`${TENANT_BASE}/status/${tenantId}`, payload);
            return response.data;
        } catch (error) {
            console.error('Error while changing the tenant status:', error);
            throw error;
        }
    },

    deleteTenant: async (tenantId, reason) => {
        try {
            const response = await apiService.delete(`${TENANT_BASE}/${tenantId}`,  {
           data: { reason },
        });
            return response.data;
        } catch (error) {
            console.error('Error while deleting tenant:', error);
            throw error;
        }
    },
};

